import { useEffect, useState } from "react";

const QUERY = "(hover: hover) and (pointer: fine)";

export const useFinePointer = () => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;

    const media = window.matchMedia(QUERY);
    const update = () => setMatches(media.matches);
    update();

    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);

  return matches;
};
